import React from 'react';

const StatsCard = ({ title, value, icon, color = 'blue', trend = null }) => {
  const colorClasses = {
    blue: 'from-blue-500/20 to-blue-600/20 border-blue-500/30',
    green: 'from-green-500/20 to-green-600/20 border-green-500/30',
    red: 'from-red-500/20 to-red-600/20 border-red-500/30',
    yellow: 'from-yellow-500/20 to-yellow-600/20 border-yellow-500/30',
    purple: 'from-purple-500/20 to-purple-600/20 border-purple-500/30',
    turquoise: 'from-turquoise-500/20 to-turquoise-600/20 border-turquoise-500/30'
  };

  const iconColorClasses = {
    blue: 'text-blue-400',
    green: 'text-green-400',
    red: 'text-red-400',
    yellow: 'text-yellow-400',
    purple: 'text-purple-400',
    turquoise: 'text-turquoise-400'
  };

  return (
    <div className={`bg-gradient-to-br ${colorClasses[color]} border rounded-16 p-6 hover:scale-105 transition-transform`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-gray-400 text-sm mb-2">{title}</p>
          <p className="text-white text-3xl font-bold mb-1">{value}</p>
          {trend && (
            <p className={`text-sm ${trend.startsWith('+') ? 'text-green-400' : 'text-red-400'}`}>
              {trend}
            </p>
          )}
        </div>
        <div className={`${iconColorClasses[color]} bg-gray-800/50 rounded-lg p-3`}>
          {icon}
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
